import { useContext, useMemo } from 'react';
import { ReservationContext } from 'Contexts/ReservationContext';
import { SharedTablePool } from 'utils/sharedTableCapacity';

/**
 * Floor-plan tables plus the day's reservations, so shared-table capacity can
 * pool seats across the tables of one multi-table reservation. Filtered like
 * the floor plan does when it maps reservations onto tables.
 */
const useSharedTablePool = (): SharedTablePool => {
  const { floorPlanProps, reservations } = useContext(ReservationContext);

  const tables = floorPlanProps.floorPlan?.tables;

  return useMemo(
    () => ({
      tables: (tables ?? []).map((t) => ({
        name: t.name,
        max: t.max,
        shared: t.shared,
      })),
      reservations: reservations.filter(
        (r) => !r.done && r.status !== 'failed' && !!r.tables?.length,
      ),
    }),
    [tables, reservations],
  );
};

export default useSharedTablePool;
